import { useTranslation } from 'react-i18next'

import styles from './milestone-list.module.scss'
import { PureTable } from '../../../../../common/ui/pure-table/pure-table'
import { MilestoneItem } from '../../../../../entities/workflow/types/workflow.types'
import { getMilestoneTransferTableColumns } from '../../helpers/get-milestone-transfer-table-columns'

type MilestoneListProps = {
  milestones: MilestoneItem[]
  onCheck: (milestoneIds: number[]) => void
}

export const MilestoneList = ({ milestones, onCheck }: MilestoneListProps) => {
  const { t } = useTranslation()
  const columns = getMilestoneTransferTableColumns()

  const rowSelection = {
    onChange: (_: any[], selectedRows: MilestoneItem[]) => {
      const ids = selectedRows.map((item) => item.id)
      onCheck(ids)
    },
  }

  return (
    <div className={styles.milestoneList}>
      <h6 className="mt-1 ml-1">{t('milestoneTransfer.table.header')}</h6>
      <PureTable
        columns={columns}
        dataSource={milestones}
        rowKey="id"
        rowSelection={rowSelection}
      />
    </div>
  )
}
